<div mat-dialog-title>Customer Details Preview</div>
<div mat-dialog-content #dialogContent>
  <div [innerHTML]="data.htmlContent"  style="overflow-y: auto; " class="customer_preview"></div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()">Close</button>
</div>
